export enum PreviewFilterType {
	BoostAndBury = 'boostandbury',
	VisibilityRules = 'visibilityrules',
	PersonalizedBoost = 'personalizedboost',
	PopularityBoost = 'popularityboost',
	ItemPin = 'itempin',
	AdvancedExplenation = 'advancedexplenation',
	FacetCoverage = 'facetcoverage',
	KeywordReplacement = 'keywordreplacement',
}
